import React from 'react';

import styles from './styles/button-box.module.css';

import Button from '../common-women/Button';
import SmallLoading from '../common/SmallLoading';

export default function ButtonBox({ text, inactiveColor, activeColor, validateBtn, handleCancle, handleClick, loading }) {
    const getBtnStyle = (isActive) => {
        return {
            backgroundColor: isActive ? activeColor : inactiveColor,
            disabled: !isActive
        };
    };

    return (
        <div className={styles.boxBtn}>
            <Button
                text='취소'
                width='fit-content'
                height='fit-content'
                padding='0'
                backgroundColor='transparent'
                borderRadius='0'
                fontSize='15px'
                fontWeight='600'
                textColor='#A9A9AE'
                onClick={handleCancle}
            />
            <Button
                text={loading ? <SmallLoading /> : text}
                width='100px'
                height='40px'
                padding='10px 30px'
                borderRadius='50px'
                fontSize='15px'
                fontWeight='600'
                textColor='#FFF'
                onClick={validateBtn() && !loading ? handleClick : null}
                {...getBtnStyle(validateBtn())}
            />
        </div>
    );
}
